import { render, staticRenderFns } from "./VentureOverview.vue?vue&type=template&id=1508abd4&scoped=true"
import script from "./VentureOverview.vue?vue&type=script&lang=js"
export * from "./VentureOverview.vue?vue&type=script&lang=js"
import style0 from "./VentureOverview.vue?vue&type=style&index=0&id=1508abd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1508abd4",
  null
  
)

export default component.exports